import React from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import { publicRoutes, allRoutes } from "./allRoutes";
import Layout from "Layout";
import NonAuthLayout from "Layout/NonLayout";
import AuthProtected from "./AuthProtected";
import { useSelector } from "react-redux";
import { createSelector } from "@reduxjs/toolkit";
import RoleProtected from "./RoleProtected";

const RouteIndex = () => {
  const selectSettings = createSelector(
    (state: any) => state.Settings,
    (state) => ({
      extensions: state.extensions,
    })
  );

  const { extensions } = useSelector(selectSettings);

  const assignedRoutes = allRoutes.filter((route) => {
    return extensions.some((extension: any) => {
      // Check if the route matches by id or if the route id exists in subItems
      return (
        extension.id === route.id || extension.subItems?.includes(route.id)
      );
    });
  });

  return (
    <React.Fragment>
      <Routes>
        <Route path="/" element={<Navigate to="/login" />} />
        {assignedRoutes.map((route: any, idx: number) => {
          return (
            <Route
              key={idx}
              path={route.path}
              element={
                <AuthProtected>
                  <RoleProtected assignedRoutes={assignedRoutes}>
                    <Layout>
                      <route.component />
                    </Layout>
                  </RoleProtected>
                </AuthProtected>
              }
            />
          );
        })}
        {/* {authProtectedRoutes.map((route: any, idx: number) => (
          <Route
            key={idx}
            path={route.path}
            element={
              <AuthProtected>
                <Layout>
                  <route.component />
                </Layout>
              </AuthProtected>
            }
          />
        ))} */}
        {publicRoutes.map((route: any, idx: number) => (
          <Route
            path={route.path}
            key={idx}
            element={
              <NonAuthLayout>
                <route.component />
              </NonAuthLayout>
            }
          />
        ))}
        <Route
          path="*"
          element={
            <RoleProtected assignedRoutes={assignedRoutes}>
              <Navigate to="/pages-404" />
            </RoleProtected>
          }
        />
      </Routes>
    </React.Fragment>
  );
};

export default RouteIndex;
